import { useCallback } from 'react';

import { useSnackbars } from '../app/error-handling/SnackBars';

const copyWithFallback = (text: string): boolean => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.left = '-9999px';
    textArea.style.position = 'fixed';
    textArea.style.top = '0';

    document.body.append(textArea);
    textArea.select();

    try {
        return document.execCommand('copy');
    } finally {
        textArea.remove();
    }
};

export const useCopyTextToClipboard = (): ((text: string) => Promise<boolean>) => {
    const { showErrorMessageSnackbar, showSuccessSnackbar } = useSnackbars();

    return useCallback(
        async (text: string): Promise<boolean> => {
            const textToCopy = text.trim();
            if (textToCopy.length === 0) {
                showErrorMessageSnackbar('pages.job-architecture-v2.comments.copy-error');
                return false;
            }

            try {
                if (!navigator.clipboard) {
                    if (!copyWithFallback(textToCopy)) {
                        throw new Error('Fallback copy failed');
                    }
                } else {
                    await navigator.clipboard.writeText(textToCopy);
                }
                showSuccessSnackbar('pages.job-architecture-v2.comments.copy-success');
                return true;
            } catch {
                if (copyWithFallback(textToCopy)) {
                    showSuccessSnackbar('pages.job-architecture-v2.comments.copy-success');
                    return true;
                }
                showErrorMessageSnackbar('pages.job-architecture-v2.comments.copy-error');
                return false;
            }
        },
        [showErrorMessageSnackbar, showSuccessSnackbar],
    );
};
